<template>
  <div class="confirm-content-block">
    <section class="section">
      <div class="vb-heading h2">
        La tua prenotazione
      </div>
    </section>
    <p class="text--lg">
      <b>{{ confirm.details.rooms[0].name }}</b>
    </p>
    <p>
      checkin <strong v-html="confirm.details.checkin" /><br>
      checkout <strong v-html="confirm.details.checkout" /><br>
      price local <strong v-html="confirm.details.price_local" /><br>
      cancellazione entro il <strong v-html="confirm.details.cancellation_date" /><br>
      ( ... )
    </p>
  </div>
</template>

<script>
export default {
  name: 'confirm-content-block',

  components: {
  },

  props: {
    confirm: Object, 
  },

  data() {
    return {
    }
  },

  computed: {
  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>
</style>